import type { HttpClient } from "../httpClient";
import { createEndpoint } from "../createEndpoint";
import { ExpertAnalyticsSchema } from "../schemas/analytics";

export function createExpertAnalyticsApi(http: HttpClient, baseUrl: string) {
    const analyticsBaseUrl = `${baseUrl}/expert`;
    return {
        getAnalytics: createEndpoint(http, 'GET', '/analytics', {
            base: analyticsBaseUrl,
            responseSchema: ExpertAnalyticsSchema,
        }),
        refreshAnalytics: createEndpoint(http, 'POST', '/analytics/refresh', {
            base: analyticsBaseUrl,
            responseSchema: ExpertAnalyticsSchema,
        }),
    };
}
